import { Routes } from '@angular/router';
import { LoginComponent } from '@core/auth/login/login.component';
import { loginGuard, authGuard } from '@core/auth/guards/auth.guard';
import { businessGuard } from '@core/guards/business.guard';
import { TrialExpiredComponent } from '@core/auth/trial-expired/trial-expired.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'trial-expired',
    component: TrialExpiredComponent,
    canActivate: [authGuard]
  },
  {
    path: '',
    canActivate: [authGuard, businessGuard],
    pathMatch: 'full',
    children: []
  },
  {
    path: 'retail',
    canActivate: [authGuard, businessGuard],
    loadChildren: () => import('@domains/retail/retail.routes').then(m => m.RETAIL_ROUTES)
  },
  {
    path: 'mobile',
    canActivate: [authGuard, businessGuard],
    loadChildren: () => import('@domains/mobile-shop/mobile.routes').then(m => m.MOBILE_ROUTES)
  },
  {
    path: 'pharmacy',
    canActivate: [authGuard, businessGuard],
    loadChildren: () => import('@domains/pharmacy/pharmacy.routes').then(m => m.PHARMACY_ROUTES)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
